import React from "react";

const ConferenceWins = ({ conferenceWins, userCount }) => {
    if (!conferenceWins || conferenceWins.length === 0) {
        return <p>No conference win data available.</p>;
    }
    return (
        <ul>
            {conferenceWins.filter((_, index) => index < userCount).map(({ conference, wins, winPercentage, totalGames }) => (
                <li key={conference}>
                    {conference}: {winPercentage}% ({wins} wins - {totalGames - wins} losses)
                </li>
            ))}
        </ul>
    );
};

export default ConferenceWins;
